module.exports = __webpack_public_path__ + "img/ethereum.50b26815.png";